// action types
export const RESET = 'RESET';
export const BACK = 'BACK';

// form status variables
export const PENDING = 'PENDING';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

// global
export const RESET_STATE = 'RESET_STATE';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_CUSTOM_APPLICATION_TITLE = 'SET_CUSTOM_APPLICATION_TITLE';
export const SET_INTENDED_FLOW = 'SET_INTENDED_FLOW';
export const SET_RENEWAL_FLOW = 'SET_RENEWAL_FLOW';
export const SET_RENEWAL_IS_VERIFICATION_REQUIRED = 'SET_RENEWAL_IS_VERIFICATION_REQUIRED';
export const SET_RENEWAL_SUPPRESS_INELIGIBLE_BANNER = 'SET_RENEWAL_SUPPRESS_INELIGIBLE_BANNER';

// admin messages
export const SET_ADMIN_MESSAGES = 'SET_ADMIN_MESSAGES';
export const SET_ADMIN_MESSAGES_ERROR = 'SET_ADMIN_MESSAGES_ERROR';
export const SET_ADMIN_MESSAGES_LOADING = 'SET_ADMIN_MESSAGES_LOADING';

// create account - account info
export const SET_CUSTOMER_PROFILE = 'SET_CUSTOMER_PROFILE';
export const SET_CREATE_ACCOUNT_PROFILE = 'SET_CREATE_ACCOUNT_PROFILE';
export const RESET_CREATE_ACCOUNT_PROFILE = 'RESET_CREATE_ACCOUNT_PROFILE';
export const SET_CUSTOMER_DRIVER_LICENSE = 'SET_CUSTOMER_DRIVER_LICENSE';
export const SET_CUSTOMER_PHOTOCARD = 'SET_CUSTOMER_PHOTOCARD';
export const SET_CUSTOMER_HEALTH_CARD = 'SET_CUSTOMER_HEALTH_CARD';
export const SET_CUSTOMER_LICENSE_PLATE = 'SET_CUSTOMER_LICENSE_PLATE';
export const SET_CUSTOMER_PROFILE_ERRORS = 'SET_CUSTOMER_PROFILE_ERRORS';

export const SET_RENEWAL_REMINDERS = 'SET_RENEWAL_REMINDERS';
export const SET_REFERRER_AS_DASHBOARD = 'SET_REFERRER_AS_DASHBOARD';
export const SHOW_RENEWAL_ALERT = 'SHOW_RENEWAL_ALERT';
export const SET_REGISTERED_PRODUCTS = 'SET_REGISTERED_PRODUCTS';
export const SET_AI_PHOTO_DATA = 'SET_AI_PHOTO_DATA';

export const ADDRESS_CHANGE_SELECT_PRODUCT = 'ADDRESS_CHANGE_SELECT_PRODUCT';
export const SET_ADDRESS_CHANGE_ELIGIBILITY_QUESTIONS = 'ADDRESS_CHANGE_ELIGIBILITY_QUESTIONS';
export const ADDRESS_CHANGE_NEW_ADDRESS = 'ADDRESS_CHANGE_NEW_ADDRESS';
export const ADDRESS_CHANGE_REVIEW = 'ADDRESS_CHANGE_REVIEW';
export const ADDRESS_CHANGE_NORTHERN_ONTARIO = 'ADDRESS_CHANGE_NORTHERN_ONTARIO';
export const SET_ADDRESS_CHANGE_DATA = 'SET_ADDRESS_CHANGE_DATA';
export const RESET_ADDRESS_CHANGE_DATA = 'RESET_ADDRESS_CHANGE_DATA';
export const ADDRESS_CHANGE_SUCCESS = 'ADDRESS_CHANGE_SUCCESS';
export const SET_ADDRESS_CHANGE_TERMS_CONDITIONS_AGREED =
    'SET_ADDRESS_CHANGE_TERMS_CONDITIONS_AGREED';

export const SET_INBOX_DATA = 'SET_INBOX_DATA';
export const SET_INBOX_MODE = 'SET_INBOX_MODE';
export const SET_INBOX_PAGE_NUMBER = 'SET_INBOX_PAGE_NUMBER';

export const RESET_RENEWAL_DATA = 'RESET_RENEWAL_DATA';
export const SET_RENEWAL_PRODUCT_TYPE = 'SET_RENEWAL_PRODUCT_TYPE';
export const SET_RENEWAL_TERMS_AND_CONDTIONS_AGREED = 'SET_RENEWAL_TERMS_AND_CONDTIONS_AGREED';
export const SET_RENEWAL_ELIGIBILITY_RESPONSE = 'SET_RENEWAL_ELIGIBILITY_RESPONSE';
export const SET_RENEWAL_DRIVERS_LICENCE_DETAILS = 'SET_RENEWAL_DRIVERS_LICENCE_DETAILS';
export const SET_RENEWAL_PHOTOCARD_DETAILS = 'SET_RENEWAL_PHOTOCARD_DETAILS';
export const RESET_RENEWAL_DRIVERS_LICENCE_DETAILS = 'RESET_RENEWAL_DRIVERS_LICENCE_DETAILS';
export const RESET_RENEWAL_PHOTOCARD_DETAILS = 'RESET_RENEWAL_PHOTOCARD_DETAILS';
export const SET_RENEWAL_HEALTH_CARD_DETAILS = 'SET_RENEWAL_HEALTH_CARD_DETAILS';
export const SET_RENEWAL_CONTACT_DETAILS = 'SET_RENEWAL_CONTACT_DETAILS';
export const SET_RENEWAL_CERTIFY_INFO = 'SET_RENEWAL_CERTIFY_INFO';
export const SET_RENEWAL_CONFIRM_VISION_CHANGE = 'SET_RENEWAL_CONFIRM_VISION_CHANGE';
export const SET_RENEWAL_ELIGIBILITY_DATA = 'SET_RENEWAL_ELIGIBILITY_DATA';
export const SET_DL_RENEWAL_ELIGIBILITY_DATA = 'SET_DL_RENEWAL_ELIGIBILITY_DATA';
export const SET_OPC_RENEWAL_ELIGIBILITY_DATA = 'SET_OPC_RENEWAL_ELIGIBILITY_DATA';
export const SET_HC_RENEWAL_ELIGIBILITY_DATA = 'SET_HC_RENEWAL_ELIGIBILITY_DATA';
export const SET_RENEWAL_PAYMENT_AMOUNT = 'SET_RENEWAL_PAYMENT_AMOUNT';
export const SET_RENEWAL_PAYMENT_TRANSACTION_DETAILS = 'SET_RENEWAL_PAYMENT_TRANSACTION_DETAILS';
export const SET_RENEWAL_HC_ORDER_STATUS = 'SET_RENEWAL_HC_ORDER_STATUS';
export const SET_RENEWAL_DL_ORDER_STATUS = 'SET_RENEWAL_DL_ORDER_STATUS';
export const SET_RENEWAL_OPC_ORDER_STATUS = 'SET_RENEWAL_OPC_ORDER_STATUS';
export const SET_RENEWAL_TRANSACTION_LOADING = 'SET_RENEWAL_TRANSACTION_LOADING';
export const SET_RENEWAL_PAYMENT_STATE = 'SET_RENEWAL_PAYMENT_STATE';
export const SET_RENEWAL_REMINDERS_DATA = 'SET_RENEWAL_REMINDERS_DATA';
export const RESET_RENEWAL_REMINDERS_DATA = 'RESET_RENEWAL_REMINERS_DATA';
export const SET_RENEWAL_IS_ONTARIO_RESIDENT = 'SET_RENEWAL_IS_ONTARIO_RESIDENT';
export const SET_DRAFTS_AND_FORMS = 'SET_DRAFTS_AND_FORMS';
export const LICENSE_PLATE_RENEWAL_DETAILS = 'LICENSE_PLATE_RENEWAL_DETAILS';
export const LICENSE_PLATE_RENEWAL_DETAILS_RESET = 'LICENSE_PLATE_RENEWAL_DETAILS_RESET';
export const LICENSE_PLATE_RENEWAL_DETAILS_UPDATE = 'LICENSE_PLATE_RENEWAL_DETAILS_UPDATE';
export const LICENSE_PLATE_RENEWAL_DETAILS_REMOVE = 'LICENSE_PLATE_RENEWAL_DETAILS_REMOVE';
export const LICENSE_PLATE_RENEWAL_MAKE_PAYMENT_START = 'LICENSE_PLATE_RENEWAL_MAKE_PAYMENT_START';
export const LICENSE_PLATE_RENEWAL_MAKE_PAYMENT_END = 'LICENSE_PLATE_RENEWAL_MAKE_PAYMENT_END';
export const LICENSE_PLATE_RENEWAL_NO_PAYMENT = 'LICENSE_PLATE_RENEWAL_NO_PAYMENT';
export const LICENSE_PLATE_RENEWAL_RESET = 'LICENSE_PLATE_RENEWAL_RESET';
export const SET_PAY_FINE_FINE_INFO = 'SET_PAY_FINE_FINE_INFO';
export const SET_PAY_FINE_GUEST_INFO = 'SET_PAY_FINE_GUEST_INFO';
export const SET_SELECTED_FINES = 'SET_SELECTED_FINES';
export const SET_SELECTED_FINES_VAL = 'SET_SELECTED_FINES_VAL';
export const SET_CHECK_AMP = 'SET_CHECK_AMP';
export const SET_CHECK_REINST = 'SET_CHECK_REINST';
export const SET_CHECK_DRFINE = 'SET_CHECK_DRFINE';
export const RESET_CHECK_AMP = 'RESET_CHECK_AMP';
export const RESET_CHECK_REINST = 'RESET_CHECK_REINST';
export const SHOW_CANCEL_ORDER_SUCCSS_MESSAGE = 'SHOW_CANCEL_ORDER_SUCCSS_MESSAGE';
export const SET_PAYFINE_ATTEMPTS = 'SET_PAYFINE_ATTEMPTS';
export const SET_PAYMENT_ORDER_DATA = 'SET_PAYMENT_ORDER_DATA';
export const DECLINED_ORDER_STATUS = 'DECLINED_ORDER_STATUS';
export const SET_CHECK_NSF = 'SET_CHECK_NSF';
export const RESET_PAYFINE = 'RESET_PAYFINE';
export const SET_DRIVERS_ABSTRACT = 'SET_DRIVERS_ABSTRACT';
export const RESET_DRIVERS_ABSTRACT = 'RESET_DRIVERS_ABSTRACT';
export const SET_VEHICLE_ABSTRACT_UNCERTIFIED = 'SET_VEHICLE_ABSTRACT_UNCERTIFIED';
export const ADD_ABSTRACT_TO_UNCERTIFIED_VEHICLE_ABSTRACTS =
    'ADD_ABSTRACT_TO_UNCERTIFIED_VEHICLE_ABSTRACTS';
export const RESET_VEHICLE_ABSTRACT_UNCERTIFIED = 'RESET_VEHICLE_ABSTRACT_UNCERTIFIED';
export const SET_CALLER_INFO = 'SET_CALLER_INFO';
export const SET_PRODUCTS_DRIVERS_LICENCE = 'SET_PRODUCTS_DRIVERS_LICENCE';
export const SET_PRODUCTS_PHOTO_CARD = 'SET_PRODUCTS_PHOTO_CARD';
export const SET_PAYFINE_INIT_BY = 'SET_PAYFINE_INIT_BY';
export const SET_VERIFY_PRODUCT_INFO = 'SET_VERIFY_PRODUCT_INFO';
